<template>
  <div>
    <div class="container-filters">
      <form class="search-filters" @submit.prevent="onApplyFilters">
        <label>
          Dată de la
          <input v-model="localFilters.dateFrom" type="date">
        </label>
        <label>
          Dată până la
          <input v-model="localFilters.dateTo" type="date">
        </label>
        <label>
          Luni min
          <select v-model.number="localFilters.minMonths">
            <option :value="null">-</option>
            <option
              v-for="month in monthOptions"
              :key="'min-' + month"
              :value="month"
            >
              {{ month }} luni
            </option>
          </select>
        </label>
        <label>
          Luni max
          <select v-model.number="localFilters.maxMonths">
            <option :value="null">-</option>
            <option
              v-for="month in monthOptions"
              :key="'max-' + month"
              :value="month"
            >
              {{ month }} luni
            </option>
          </select>
        </label>
        <button type="submit" class="search-btn">
          <img src="../assets/icons2/search-icon.svg" alt="search-icon">
        </button>
      </form>

      <div class="action-bar">
        <button class="download-btn" @click="$emit('download', localFilters)" :disabled="isDownloading || isLoading">
          <span v-if="!isDownloading">📥 Descarcă Excel</span>
          <span v-else class="btn-spinner"></span>
        </button>
      </div>
    </div>

    <div class="table-wrapper" :class="{ 'is-loading': isLoading }">
      <div v-if="isLoading" class="table-loader-overlay">
        <div class="spinner"></div>
        <p>Se încarcă datele...</p>
      </div>

      <table class="table">
        <thead>
        <tr>
          <th>#</th>
          <th>Nume</th>
          <th>Prenume</th>
          <th>Ultima igienizare</th>
          <th>Luni întârziere</th>
          <th>Zile întârziere</th>
          <th>Urgență</th>
          <th>Medic</th>
          <th>Oraș</th>
          <th>Telefon</th>
          <th>Email</th>
        </tr>
        </thead>
        <tbody>
        <tr v-if="items.length === 0">
          <td colspan="11" class="no-data">Nu există pacienți cu igienizare întârziată</td>
        </tr>
        <tr v-else v-for="(item, index) in items" :key="item._id">
          <td>{{ index + 1 }}</td>
          <td>{{ item.nume }}</td>
          <td>{{ item.prenume }}</td>
          <td>{{ item.lastIgienizareDate }}</td>
          <td>{{ item.monthsSinceLastIgienizare }}</td>
          <td>{{ item.daysSinceLastIgienizare }}</td>
          <td>
              <span class="urgency-badge" :class="'urgency-' + item.urgency">
                {{ getUrgencyLabel(item.urgency) }}
              </span>
          </td>
          <td>{{ item.medic }}</td>
          <td>{{ item.oras }}</td>
          <td>{{ item.telefon || '-' }}</td>
          <td>{{ item.email !== 'N/A' ? item.email : '-' }}</td>
        </tr>
        </tbody>
      </table>
    </div>

    <div class="summary">
      <span>Total pacienți cu igienizare întârziată: <b>{{ total }}</b></span>
      <span style="margin-left: 20px;">Prag de alertă: <b>{{ thresholdMonths }} luni</b></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IgienizareOverdue',

  props: {
    items: { type: Array, default: () => [] },
    total: { type: Number, default: 0 },
    thresholdMonths: { type: Number, default: 0 },
    isLoading: { type: Boolean, default: false },
    isDownloading: { type: Boolean, default: false }
  },

  emits: ['apply-filters', 'download'],

  data () {
    return {
      monthOptions: [3, 6, 12],
      localFilters: {
        dateFrom: '',
        dateTo: '',
        minMonths: null,
        maxMonths: null
      }
    }
  },

  methods: {
    onApplyFilters () {
      this.$emit('apply-filters', { ...this.localFilters })
    },

    getUrgencyLabel (urgency) {
      const labels = { high: 'Ridicată', medium: 'Medie', low: 'Scăzută' }
      return labels[urgency] || urgency
    }
  }
}
</script>

<style lang="less">
@import '../assets/styles/var.less';

.container-filters {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .search-filters {
    display: flex;
    align-items: end;
    margin-bottom: 12px;
    gap: 8px;

    .search-btn {
      background-color: @main-green;
      border: none;
      border-radius: 100%;
      height: 34px;
      width: 34px;
      display: flex;
      cursor: pointer;
      align-items: center;
      justify-content: center;
      transition: opacity 0.1s ease-in-out;

      &:hover {
        opacity: 0.8;
      }
    }

    label {
      display: block;
      font-size: 15px;
      select {
        display: block;
        font-size: 15px;
        border-radius: 2px;
        margin-top: 5px;
        padding: 2px 10px;
        width: 160px;
        height: 35px;
        border: 1px solid #ddd;
      }
      input {
        display: block;
        font-size: 15px;
        border-radius: 2px;
        margin-top: 5px;
        padding: 2px 10px;
        width: 160px;
        height: 35px;
        border: 1px solid #ddd;
      }
    }
  }
}
</style>
